import React from 'react';
import {ListingLayoutProps} from '../props';
import {
  makeLinkContainerProps,
  makeToggleProps,
  useToolbarProps
} from "../../../../shared/propsBuilders/listingPropsBuilder";

import LinkContainer from "../../../private/LinkContainer/LinkContainer";
import Toolbar from "../../../private/Toolbar/Toolbar";
import Toggle from "../../../private/Toggle/Toggle";
import ListingPreview from "../../../private/ListingPreview/ListingPreview";
import Divider from "../../../private/Divider/Divider";
import Footer from "../../../private/Footer/Footer";

export function ListingLayout(props: ListingLayoutProps) {
  const {classNames, height, footerProps, listingPreviewProps} = props;
  const linkProps = makeLinkContainerProps(props);
  const selector = !props.hyperlinkAttributes ? linkProps.dataSelector : {};

  return (
    <LinkContainer {...linkProps}>
      <span
        className={classNames}
        onClick={props.onClick}
        style={{height: height}}
        {...selector}
      >
        <Toolbar {...useToolbarProps(props)} />
        {props.like && <Toggle {...makeToggleProps(props)}></Toggle>}
        <ListingPreview {...listingPreviewProps}></ListingPreview>
        <Divider></Divider>
        <Footer {...footerProps}></Footer>
      </span>
    </LinkContainer>
  );
}

export default ListingLayout;
